/**
 * Strickset Handler – Unified Bundle System
 * ==========================================
 * Ersetzt BundleOptions, BundleVariantReplacer, MultiBundleHandler
 * und MultiBundleOptions durch EINE Klasse.
 *
 * Liest die Konfiguration aus dem DOM (gerendert von strickset-variants.liquid)
 * und erzeugt die items[]-Inputs für den Warenkorb.
 *
 * Custom Elements:
 *   <strickset-handler>  – Hauptlogik (Preis, Inputs, Verfügbarkeit, Lieferzeit)
 *   <strickset-selector> – Einzelner Garn-Farbwähler (Bild, Overlay, Radio-Inputs)
 */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     StricksetSelector – Farbwahl pro Garn-Slot
     ────────────────────────────────────────────── */
  class StricksetSelector extends HTMLElement {
    connectedCallback() {
      this.index = parseInt(this.getAttribute('data-index'));
      this.group = this.getAttribute('group');
      this.productHandle = this.getAttribute('data-product-handle');

      this.imageBtn = this.querySelector('.multi-bundle-color-image-btn');
      this.colorImage = this.querySelector('.multi-bundle-color-image');
      this.colorName = this.querySelector('.color-name');
      this.overlay = this.querySelector('.multi-bundle-color-overlay');
      this.radios = this.querySelectorAll('input[type="radio"]');

      this._initOverlay();
      this._initColorOptions();
    }

    /** Overlay öffnen/schließen */
    _initOverlay() {
      if (!this.imageBtn || !this.overlay) return;

      var self = this;
      this.imageBtn.addEventListener('click', function () {
        self._updateOverlayAvailability();
        self.overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      var closeBtn = this.overlay.querySelector('.multi-bundle-overlay-close');

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          self._closeOverlay();
        });
      }

      // Klick außerhalb des Inhalts (auf Backdrop oder Overlay-Rand) schließt Overlay
      this.overlay.addEventListener('click', function (e) {
        if (!e.target.closest('.multi-bundle-overlay-content')) {
          self._closeOverlay();
        }
      });
    }

    _closeOverlay() {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    /** Markiert Farboptionen im Overlay als nicht verfügbar wenn Stock < benötigte Menge */
    _updateOverlayAvailability() {
      var handler = document.querySelector('strickset-handler[group="' + this.group + '"]');
      if (!handler) return;

      var neededQty = 1;
      if (handler.currentConstellation && handler.currentConstellation[this.index] !== undefined) {
        neededQty = handler.currentConstellation[this.index];
      }
      if (neededQty === 0) return;

      // Andere Slots: Wie viel von derselben Variante wird dort schon benötigt?
      var otherSelectors = document.querySelectorAll('strickset-selector[group="' + this.group + '"]');
      var otherUsage = {}; // variantId → totalQty aus anderen Slots
      otherSelectors.forEach(function (sel) {
        if (sel === this) return;
        var otherVariant = sel.getSelectedVariant ? sel.getSelectedVariant() : null;
        if (!otherVariant || !otherVariant.id) return;
        var otherIdx = parseInt(sel.getAttribute('data-index'));
        var otherQty = 1;
        if (handler.currentConstellation && handler.currentConstellation[otherIdx] !== undefined) {
          otherQty = handler.currentConstellation[otherIdx];
        }
        if (otherQty === 0) return;
        var vid = String(otherVariant.id);
        otherUsage[vid] = (otherUsage[vid] || 0) + otherQty;
      }.bind(this));

      var options = this.overlay.querySelectorAll('.multi-bundle-color-option');
      options.forEach(function (opt) {
        var variantId = String(opt.getAttribute('data-variant-id') || '');
        if (!variantId) return;

        var stockEl = document.querySelector('[data-strickset-variant-stock="' + variantId + '"]');
        if (!stockEl) return;

        var stock = parseInt(stockEl.getAttribute('data-stock')) || 0;
        var policy = stockEl.getAttribute('data-inventory-policy') || 'deny';
        var allowsBackorder = policy === 'continue';

        var totalNeeded = neededQty + (otherUsage[variantId] || 0);

        if (!allowsBackorder && stock < totalNeeded) {
          opt.setAttribute('data-unavailable', 'true');
          opt.setAttribute('data-unavailable-reason', 'stock-insufficient');
        } else if (opt.getAttribute('data-unavailable-reason') === 'stock-insufficient') {
          opt.removeAttribute('data-unavailable');
          opt.removeAttribute('data-unavailable-reason');
        }
      });
    }

    /** Farboptionen im Overlay: Klick → Radio updaten → Bild updaten → Event feuern */
    _initColorOptions() {
      var self = this;
      var options = this.querySelectorAll('.multi-bundle-color-option');

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var variantId = opt.getAttribute('data-variant-id');
          self._selectVariant(variantId);
          self._closeOverlay();
        });
      });
    }

    /** Variante programmatisch auswählen (für Farbempfehlungen) */
    selectByTitle(title) {
      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].getAttribute('data-title') === title) {
          this._selectVariant(this.radios[i].value);
          return true;
        }
      }
      return false;
    }

    /** Interne Selektion: Radio, Bild, Label, Event */
    _selectVariant(variantId) {
      // Radio-Input updaten
      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].value === variantId) {
          this.radios[i].checked = true;
          break;
        }
      }

      // Bild und Label updaten
      var checkedRadio = this.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        var variantData = null;
        try {
          variantData = JSON.parse(checkedRadio.getAttribute('data-variant'));
        } catch (e) { /* ignore */ }

        if (variantData && variantData.featured_image) {
          var imgUrl300 = variantData.featured_image.src.replace(/(\.\w+)$/, '_300x$1');
          var imgUrl600 = variantData.featured_image.src.replace(/(\.\w+)$/, '_600x$1');
          if (this.colorImage) {
            this.colorImage.src = imgUrl300;
            this.colorImage.srcset = imgUrl300 + ' 1x, ' + imgUrl600 + ' 2x';
            this.colorImage.alt = variantData.title || '';
          }
        }
        if (this.colorName) {
          this.colorName.textContent = checkedRadio.getAttribute('data-title') || '';
        }
      }

      // Event an Handler feuern
      this.dispatchEvent(new CustomEvent('strickset:variant-changed', {
        bubbles: true,
        detail: { index: this.index, variantId: variantId }
      }));
    }

    /** Aktuell gewählte Variante */
    getSelectedVariant() {
      var checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return null;
      try {
        var data = JSON.parse(checked.getAttribute('data-variant'));
        return data;
      } catch (e) {
        return { id: parseInt(checked.value) };
      }
    }
  }

  customElements.define('strickset-selector', StricksetSelector);


  /* ──────────────────────────────────────────────
     StricksetHandler – Hauptlogik
     ────────────────────────────────────────────── */
  class StricksetHandler extends HTMLElement {
    connectedCallback() {
      this.group = this.getAttribute('group');
      this.productTitle = this.getAttribute('data-product-title') || '';
      // Für die Zubehör-Zeile im Warenkorb: welches Strickset-Produkt gehört zu den Garnen (03.10.2026)
      this.productHandle = this.getAttribute('data-product-handle') || '';
      this.productVariantId = this.getAttribute('data-product-variant-id') || '';
      this.farbmodus = this.getAttribute('data-farbmodus') || 'multi';
      this.garneCount = parseInt(this.getAttribute('data-garne-count')) || 0;
      this.allowPartial = this.hasAttribute('data-allow-partial');
      this.digitalAutoAddVariantId = this.getAttribute('data-digital-auto-add') || '';
      this.digitalAutoAddPrice = parseInt(this.getAttribute('data-digital-auto-add-price') || '0', 10);
      try {
        var rawAutoAdd = this.getAttribute('data-auto-add-items');
        this.autoAddItems = rawAutoAdd ? JSON.parse(rawAutoAdd) : [];
      } catch(e) { this.autoAddItems = []; }

      this.productForm = null;
      this.selectors = [];
      this.constellations = {};
      this.currentConstellation = null;
      this._deliveryTimeTimeout = null;
      this._submitting = false;

      this._findForm();
      this._findSelectors();
      this._parseConstellations();
      this._initSizeDropdown();
      this._initCollections();
      this._finderVorauswahl();

      // Auf Farbwechsel in Selektoren reagieren
      var self = this;
      document.addEventListener('strickset:variant-changed', function (e) {
        self._onVariantChanged(e.detail);
      });

      // Shopify-Standard-Elemente ausblenden (wir steuern Preis/Verfügbarkeit selbst)
      this._hideShopifyDefaults();

      // Form-Submit abfangen (Shopify's product-form validiert die Variant-ID,
      // aber wir nutzen items[] statt einer einzelnen ID)
      this._interceptFormSubmit();

      // Initialer Zustand
      this._updateConstellation();
      this.createInputs();
    }

    /* ── Form-Submit abfangen und direkt an Cart API senden ── */
    _interceptFormSubmit() {
      if (!this.productForm) return;
      var self = this;

      // Submit-Button von type="submit" → type="button" ändern.
      // Das verhindert zuverlässig jede Browser-seitige Form-Submission,
      // egal welche anderen Event-Listener noch registriert sind.
      var submitBtn = this.productForm.querySelector('button[type="submit"], .product-form__submit, button[name="add"]');
      if (submitBtn) {
        submitBtn.type = 'button';
        submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!self._submitting) self._submitToCart();
        });
      }

      // Form-Submit als zusätzliche Sicherheitsnetz (z.B. Enter-Taste)
      this.productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!self._submitting) self._submitToCart();
        return false;
      }, true);
    }

    /** Cart API Submit */
    _submitToCart() {
      var self = this;
      this._submitting = true;
      var submitBtn = this.productForm.querySelector('button[type="button"].product-form__submit, button[type="button"][name="add"], button[type="submit"], .product-form__submit');

      // Verfügbarkeit nochmal prüfen (der Hinweis erscheint dabei von selbst).
      // Sperre wieder lösen, sonst reagiert der Knopf nach einem Farbwechsel nicht mehr.
      if (!this.calculateAvailability()) {
        this._submitting = false;
        return;
      }

      // Items aus den hidden inputs sammeln (Garne + gedruckte Anleitung)
      var allInputs = Array.from(this.productForm.querySelectorAll('input[data-strickset-input], input[data-instruction-input]'));
      var items = {};
      allInputs.forEach(function (input) {
        var match = input.name.match(/^items\[(\d+)\]\[(.+)\]$/);
        if (!match) return;
        var index = match[1];
        var field = match[2];
        if (!items[index]) items[index] = {};

        // Properties parsen: items[0][properties][Bundle] → {properties: {Bundle: "..."}}
        var propMatch = field.match(/^properties\]\[(.+)$/);
        if (propMatch) {
          if (!items[index].properties) items[index].properties = {};
          items[index].properties[propMatch[1]] = input.value;
        } else {
          items[index][field] = input.value;
        }
      });

      var itemsArray = Object.values(items).map(function (item) {
        return {
          id: parseInt(item.id),
          quantity: parseInt(item.quantity) || 1,
          properties: item.properties || {}
        };
      }).filter(function (item) { return item.id > 0; });

      // Aus dem Strickset-Finder gekommen (?fd=1): an jeder Position vermerken und als
      // Warenkorb-Attribut „Finder“ setzen – beides landet in der Bestellung (Messung, 08.10.2026)
      var ausFinder = new URLSearchParams(location.search).get('fd') === '1';
      if (ausFinder) itemsArray.forEach(function (item) { item.properties._Finder = 'ja'; });

      if (itemsArray.length === 0) {
        console.warn('[StricksetHandler] Keine Items zum Hinzufügen');
        this._submitting = false;
        return;
      }

      // Button deaktivieren während des Requests
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('loading');
      }

      // Alten Warenkorb-Fehler ausblenden (ein Bestandshinweis wäre hier schon weg,
      // sonst hätte calculateAvailability oben abgebrochen)
      this._versteckeHinweis('warenkorb');

      // Sections für Mini-Cart mitladen (Theme erwartet das)
      var miniCart = document.querySelector('mini-cart');
      var sections = [];
      if (miniCart && miniCart.getSectionsToRender) {
        sections = miniCart.getSectionsToRender().map(function (s) { return s.id; });
      }

      var requestBody = { items: itemsArray };
      if (sections.length > 0) {
        requestBody.sections = sections;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Fehler beim Hinzufügen');
          });
        }
        return response.json();
      })
      .then(function (data) {
        self._submitting = false;
        if (ausFinder) {
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { Finder: 'ja' } }) }).catch(function () {});
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('loading');
        }

        // Mini-Cart Drawer öffnen (Theme-Methode)
        if (miniCart && miniCart.renderContents) {
          miniCart.renderContents(data);
        }
      })
      .catch(function (error) {
        self._submitting = false;
        console.error('[StricksetHandler] Cart Error:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('loading');
        }
        // Fehlermeldung sichtbar anzeigen. Meist hat sich der Bestand geändert,
        // seit die Seite geladen wurde – die Seite kennt dann alte Zahlen.
        var text = (error && error.message) || 'Das Strickset konnte nicht in den Warenkorb gelegt werden.';
        text += ' Wahrscheinlich hat sich der Bestand gerade geändert – bitte lade die Seite neu und wähle die Farben noch einmal.';
        if (self._hinweisBox()) {
          self._zeigeHinweis(text, 'warenkorb');
        } else {
          alert(text);
        }
      });
    }

    /* ── Shopify-Standard-Elemente ausblenden ── */
    _hideShopifyDefaults() {
      var self = this;
      // Sofort ausführen + verzögert (Klaviyo/Apps laden nach uns)
      this._doHideDefaults();
      setTimeout(function () { self._doHideDefaults(); }, 500);
      setTimeout(function () { self._doHideDefaults(); }, 2000);
      setTimeout(function () { self._doHideDefaults(); }, 5000);
    }

    _doHideDefaults() {
      var section = this.closest('section');
      if (!section) return;

      // 1. "Ausverkauft"-Badge neben dem Preis
      var soldOutBadge = section.querySelector('.price__badge-sold-out');
      if (soldOutBadge) soldOutBadge.style.display = 'none';

      // 2. "price--sold-out" Klasse vom Preis-Container entfernen
      var priceContainer = section.querySelector('.price--sold-out');
      if (priceContainer) priceContainer.classList.remove('price--sold-out');

      // 3. Alte Bundle-Lieferzeit (alle Varianten des Selektors)
      document.querySelectorAll('.bundle-delivery-time, #bundle-delivery-time-container, #single-bundle-delivery-time, [id^="multi-bundle-delivery-time"]').forEach(function (el) {
        el.style.display = 'none';
      });

      // 4. Variant-Info Block (enthält "Nicht auf Lager" und "Lieferzeit: Bis zu X Tage")
      // Muss !important nutzen weil custom.js den Wert wieder überschreibt
      var variantInfo = document.getElementById('variant-info');
      if (variantInfo) variantInfo.style.setProperty('display', 'none', 'important');

      var customLiquid = variantInfo ? variantInfo.closest('.custom__liquid') : null;
      if (customLiquid) customLiquid.style.setProperty('display', 'none', 'important');

      // 5. Shopify product-form Error-Wrapper ausblenden
      var errorWrapper = section.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) errorWrapper.setAttribute('hidden', '');

      // 6. Klaviyo "BENACHRICHTIGE MICH" Button (lädt oft verzögert)
      document.querySelectorAll('[class*="kl-private-reset-css"], [class*="klaviyo-bis"]').forEach(function (el) {
        if (el.textContent.indexOf('BENACHRICHTIGE') !== -1 || el.textContent.indexOf('Notify') !== -1) {
          el.style.display = 'none';
        }
      });

      // 6. Submit-Button: "Ausverkauft" → "In den Warenkorb"
      var submitBtn = section.querySelector('button[type="submit"], .product-form__submit');
      if (submitBtn) {
        var btnText = submitBtn.textContent.trim();
        if (btnText.indexOf('Ausverkauft') !== -1 || btnText.indexOf('ausverkauft') !== -1 || btnText.toLowerCase().indexOf('sold out') !== -1) {
          submitBtn.textContent = theme.variantStrings ? theme.variantStrings.addToCart || 'In den Warenkorb' : 'In den Warenkorb';
        }
      }
    }

    /* ── Form finden ── */
    _findForm() {
      // Strategie 1: Form über den Submit-Button finden (zuverlässigste Methode)
      var submitBtn = document.querySelector('button[name="add"], .product-form__submit');
      if (submitBtn) {
        this.productForm = submitBtn.closest('form');
      }

      // Strategie 2: product-form Custom Element (kann mehrfach auf Seite existieren,
      // nehmen wir das erste das eine sichtbare Form enthält)
      if (!this.productForm) {
        var productFormEls = document.querySelectorAll('product-form');
        for (var i = 0; i < productFormEls.length; i++) {
          var f = productFormEls[i].querySelector('form');
          if (f) { this.productForm = f; break; }
        }
      }

      // Strategie 3: Fallback
      if (!this.productForm) {
        this.productForm = document.querySelector('form[action*="/cart/add"]');
      }

      if (!this.productForm) {
        console.warn('[StricksetHandler] Kein Formular gefunden');
      }
    }

    /* ── Selektoren sammeln ── */
    _findSelectors() {
      this.selectors = document.querySelectorAll(
        'strickset-selector[group="' + this.group + '"]'
      );
    }

    /* ── Constellations parsen ── */
    _parseConstellations() {
      var container = document.querySelector(
        '.strickset-constellations[data-section-id="' + this.group + '"]'
      );
      if (!container) return;

      var items = container.querySelectorAll('.constellation');
      for (var i = 0; i < items.length; i++) {
        var name = items[i].getAttribute('data-constellation');
        var mengenStr = items[i].getAttribute('data-mengen');
        if (name && mengenStr) {
          this.constellations[name] = mengenStr.split('_').map(function (m) {
            return parseInt(m) || 0;
          });
        }
      }

      // Standard: erste Constellation
      var keys = Object.keys(this.constellations);
      if (keys.length > 0) {
        this.currentConstellation = this.constellations[keys[0]];
      }
    }

    /* ── Größen-Dropdown Listener ── */
    _initSizeDropdown() {
      var self = this;

      // Mehrdimensionale Selects
      var dimSelects = document.querySelectorAll(
        '.strickset-dimension-select[data-section-id="' + this.group + '"]'
      );
      if (dimSelects.length > 0) {
        dimSelects.forEach(function (sel) {
          sel.addEventListener('change', function () {
            self._updateCombinedSelect();
            self._updateConstellation();
            self.createInputs();
          });
        });
        // Button-Gruppen: Klick → hidden Select aktualisieren
        var dimBtns = document.querySelectorAll('.strickset-dim-btn[data-section-id="' + this.group + '"]');
        dimBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var idx = btn.getAttribute('data-dimension-index');
            var val = btn.getAttribute('data-value');
            // Aktiv-Klasse in dieser Gruppe wechseln
            var group2 = document.querySelectorAll('.strickset-dim-btn[data-section-id="' + self.group + '"][data-dimension-index="' + idx + '"]');
            group2.forEach(function (b) { b.classList.remove('strickset-dim-btn--active'); });
            btn.classList.add('strickset-dim-btn--active');
            // Hidden Select aktualisieren
            var sel2 = document.querySelector('.strickset-dimension-select[data-section-id="' + self.group + '"][data-dimension-index="' + idx + '"]');
            if (sel2) { sel2.value = val; sel2.dispatchEvent(new Event('change')); }
          });
        });
        // Initialen kombinierten Wert setzen
        this._updateCombinedSelect();
        return;
      }

      // Einfacher Dropdown
      var dropdown = document.querySelector('.strickset-size-select[data-option-key]');
      if (!dropdown) dropdown = document.querySelector('.bundle-size-select');
      if (dropdown) {
        dropdown.addEventListener('change', function () {
          self._updateConstellation();
          self.createInputs();
        });
      }
    }

    /* ── Kombinierten Select aus Dimension-Selects aktualisieren ── */
    _updateCombinedSelect() {
      var self = this;
      var dimSelects = document.querySelectorAll(
        '.strickset-dimension-select[data-section-id="' + this.group + '"]'
      );
      if (!dimSelects.length) return;

      var parts = [];
      dimSelects.forEach(function (sel) { parts.push(sel.value); });
      var combined = parts.join(' / ');

      var combinedSel = document.querySelector(
        '.strickset-combined-select[data-section-id="' + this.group + '"]'
      );
      if (combinedSel) {
        combinedSel.value = combined;
      }
      self._activeDimensions = [];
      dimSelects.forEach(function (sel) {
        self._activeDimensions.push({
          label: sel.getAttribute('data-dimension-label'),
          value: sel.value
        });
      });
    }

    /* ── Constellation aus Dropdown-Wert aktualisieren ── */
    _updateConstellation() {
      var dropdown = document.querySelector('.strickset-size-select, .bundle-size-select');
      if (dropdown && dropdown.value) {
        var key = dropdown.value.toLowerCase().trim();
        if (this.constellations[key]) {
          this.currentConstellation = this.constellations[key];
        }
      }
      this._updateSelectorVisibility();
    }

    /* ── Selektoren ein-/ausblenden basierend auf Mengen ── */
    _updateSelectorVisibility() {
      if (!this.currentConstellation || !this.selectors.length) return;
      for (var i = 0; i < this.selectors.length; i++) {
        var sel = this.selectors[i];
        var idx = parseInt(sel.getAttribute('data-index'));
        var qty = this.currentConstellation[idx];
        // undefined = außerhalb der Constellation (z.B. Anleitung) → nicht anfassen
        if (qty === undefined || qty === null) continue;
        if (parseInt(qty) === 0) {
          sel.style.display = 'none';
        } else {
          // Anleitungs-Slots bleiben immer versteckt
          if (!sel.classList.contains('bundle-instruction-hidden')) {
            sel.style.display = '';
          }
        }
      }
    }

    /* ── Farbempfehlungen/Kollektionen ── */
    _initCollections() {
      this.collections = [];
      this._activeCollectionIndex = null;

      var rawJson = this.getAttribute('data-farbempfehlungen');
      if (rawJson) {
        try {
          var parsed = JSON.parse(rawJson);
          if (Array.isArray(parsed)) {
            this.collections = parsed.map(function (c) {
              return {
                name: c.name || 'Unbenannt',
                colors: (c.farben || [])
              };
            });
          }
        } catch (e) {
          console.warn('[StricksetHandler] Farbempfehlungen parse error:', e);
        }
      }

      // Tile-Klicks
      var self = this;
      var tiles = document.querySelectorAll('.color-collection-tile[data-section-id="' + this.group + '"]');
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          var idx = parseInt(tile.getAttribute('data-collection-index'));
          self._applyCollection(idx);

          // Active-State auf Tiles
          tiles.forEach(function (t) { t.classList.remove('color-collection-tile--active'); });
          tile.classList.add('color-collection-tile--active');
        });
      });

      // Erste Kollektion initial anwenden
      if (this.collections.length > 0) {
        this._activeCollectionIndex = 0;
        this._applyCollection(0);
      }
    }

    /* ── Vorauswahl aus dem Strickset-Finder (assets/lianne-finder.js) ──
       ?groesse=<Größenname>&farben=<Varianten-ID je Garnindex, kommagetrennt>&welt=<Farbwelt> */
    _finderVorauswahl() {
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      var groesse = q.get('groesse'), farben = q.get('farben'), welt = q.get('welt');
      if (!groesse && !farben) return;
      var gesetzt = [];
      if (groesse) {
        var sel = document.querySelector('.strickset-size-select');
        if (sel && [].some.call(sel.options, function (o) { return o.value === groesse; })) {
          sel.value = groesse;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          gesetzt.push('Größe ' + groesse);
        }
      }
      if (farben) {
        var ids = farben.split(','), n = 0;
        for (var i = 0; i < this.selectors.length; i++) {
          var idx = parseInt(this.selectors[i].getAttribute('data-index'));
          var id = ids[idx];
          if (!id || !this.selectors[i].radios) continue;
          var gibt = [].some.call(this.selectors[i].radios, function (r) { return r.value === id && !r.disabled; });
          if (gibt) { this.selectors[i]._selectVariant(id); n++; }
        }
        if (n) {
          this._activeCollectionIndex = null;
          document.querySelectorAll('.color-collection-tile[data-section-id="' + this.group + '"]').forEach(function (t) { t.classList.remove('color-collection-tile--active'); });
          gesetzt.push(welt ? 'Farben aus Deiner Farbwelt „' + welt + '“' : 'Farben');
        }
      }
      // Kein eigener Hinweis mehr (Entscheidung 07.10.2026): Die Farbwelt erscheint markiert im Farbbereich
      // (assets/lianne-farbwelten.js), die Größe ist einfach gewählt.
    }

    /** Farbempfehlung auf alle Selektoren anwenden */
    _applyCollection(index) {
      if (index < 0 || index >= this.collections.length) return;
      var colors = this.collections[index].colors;
      this._activeCollectionIndex = index;

      // farben[] ist positionsgebunden zu garne[] (inkl. Auto-Add-Garne ohne
      // Selektor) – deshalb über data-index zuordnen, nicht über die Selektor-Reihenfolge.
      for (var i = 0; i < this.selectors.length; i++) {
        var garnIndex = parseInt(this.selectors[i].getAttribute('data-index'));
        var farbe = colors[garnIndex];
        if (farbe && this.selectors[i].selectByTitle) {
          this.selectors[i].selectByTitle(farbe);
        }
      }
    }

    /* ── Varianten-Wechsel Handler ── */
    _onVariantChanged(detail) {
      this.createInputs();
    }

    /* ════════════════════════════════════════════
       createInputs – Erzeugt items[]-Inputs im Form
       ════════════════════════════════════════════ */
    createInputs() {
      if (!this.productForm) return;

      // Alte Strickset-Inputs entfernen
      var oldInputs = this.productForm.querySelectorAll('input[data-strickset-input]');
      for (var i = 0; i < oldInputs.length; i++) {
        oldInputs[i].remove();
      }

      var timestamp = Date.now();
      var itemIndex = 0;

      for (var si = 0; si < this.selectors.length; si++) {
        var selector = this.selectors[si];
        var selectorIndex = parseInt(selector.getAttribute('data-index'));
        var variant = selector.getSelectedVariant();
        if (!variant || !variant.id) continue;

        // Menge aus Constellation
        var qty = 1;
        if (this.currentConstellation && this.currentConstellation[selectorIndex] !== undefined) {
          qty = this.currentConstellation[selectorIndex];
        }

        // Überspringe wenn Menge explizit 0
        if (qty === 0) continue;

        // Anleitungen brauchen immer nur 1
        var productType = (selector.getAttribute('data-product-type') || '').toLowerCase();
        var isInstruction = productType.indexOf('anleitung') !== -1 ||
                            productType.indexOf('strickanleitung') !== -1;
        if (isInstruction) qty = 1;

        this._appendInput('items[' + itemIndex + '][id]', variant.id);
        this._appendInput('items[' + itemIndex + '][quantity]', qty);
        this._appendInput('items[' + itemIndex + '][properties][Bundle]', this.productTitle);
        if (this.productHandle) this._appendInput('items[' + itemIndex + '][properties][_BundleHandle]', this.productHandle);
        this._appendInput('items[' + itemIndex + '][properties][_BundleID]', timestamp);

        if (this.allowPartial) {
          this._appendInput('items[' + itemIndex + '][properties][_BundleAllowPartial]', 'true');
        }

        // Größe / Optionen als Properties
        var dimSelects = document.querySelectorAll(
          '.strickset-dimension-select[data-section-id="' + this.group + '"]'
        );
        if (dimSelects.length > 0) {
          // Mehrdimensional: jede Dimension als eigene Property
          dimSelects.forEach(function (sel) {
            var label = sel.getAttribute('data-dimension-label') || 'Größe';
            if (sel.value) {
              this._appendInput('items[' + itemIndex + '][properties][' + label + ']', sel.value);
            }
          }.bind(this));
        } else {
          var sizeDropdown = document.querySelector('.strickset-size-select, .bundle-size-select');
          if (sizeDropdown && sizeDropdown.value) {
            this._appendInput('items[' + itemIndex + '][properties][Größe]', sizeDropdown.value);
          }
        }

        itemIndex++;
      }

      // Auto-Add: Feste Artikel ohne Farbwahl (z.B. Marketing Kit, Bundle-Zubehör)
      for (var ai = 0; ai < this.autoAddItems.length; ai++) {
        var autoItem = this.autoAddItems[ai];
        var autoQty = 1;
        if (this.currentConstellation && this.currentConstellation[autoItem.index] !== undefined) {
          autoQty = parseInt(this.currentConstellation[autoItem.index]) || 1;
        }
        if (autoQty === 0) continue;
        this._appendInput('items[' + itemIndex + '][id]', autoItem.variantId);
        this._appendInput('items[' + itemIndex + '][quantity]', autoQty);
        this._appendInput('items[' + itemIndex + '][properties][Bundle]', this.productTitle);
        if (this.productHandle) this._appendInput('items[' + itemIndex + '][properties][_BundleHandle]', this.productHandle);
        this._appendInput('items[' + itemIndex + '][properties][_BundleID]', timestamp);
        var dimSelects2 = document.querySelectorAll('.strickset-dimension-select[data-section-id="' + this.group + '"]');
        if (dimSelects2.length > 0) {
          dimSelects2.forEach(function (sel) {
            var label = sel.getAttribute('data-dimension-label') || 'Größe';
            if (sel.value) this._appendInput('items[' + itemIndex + '][properties][' + label + ']', sel.value);
          }.bind(this));
        } else {
          var sizeDropdown2 = document.querySelector('.strickset-size-select, .bundle-size-select');
          if (sizeDropdown2 && sizeDropdown2.value) {
            this._appendInput('items[' + itemIndex + '][properties][Größe]', sizeDropdown2.value);
          }
        }
        itemIndex++;
      }

      // Auto-Add: Digitale Anleitung (Lianne-eigene Sets)
      if (this.digitalAutoAddVariantId) {
        this._appendInput('items[' + itemIndex + '][id]', this.digitalAutoAddVariantId);
        this._appendInput('items[' + itemIndex + '][quantity]', '1');
        this._appendInput('items[' + itemIndex + '][properties][Bundle]', this.productTitle);
        if (this.productHandle) this._appendInput('items[' + itemIndex + '][properties][_BundleHandle]', this.productHandle);
        this._appendInput('items[' + itemIndex + '][properties][_BundleID]', timestamp);
        itemIndex++;
      }

      this.calcPrice();
      this.calculateAvailability();
      this.calculateDeliveryTime();
      this.reenableSubmitButton();
    }

    /** Hidden Input ins Form einfügen */
    _appendInput(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('data-strickset-input', '');
      this.productForm.appendChild(input);
    }

    /* ════════════════════════════════════════════
       Preisberechnung
       ════════════════════════════════════════════ */
    calcPrice() {
      var price = 0;

      for (var si = 0; si < this.selectors.length; si++) {
        var selector = this.selectors[si];
        var selectorIndex = parseInt(selector.getAttribute('data-index'));
        var variant = selector.getSelectedVariant();
        if (!variant || !variant.price) continue;

        var qty = 1;
        if (this.currentConstellation && this.currentConstellation[selectorIndex] !== undefined) {
          qty = this.currentConstellation[selectorIndex];
        }
        if (qty === 0) continue;

        var productType = (selector.getAttribute('data-product-type') || '').toLowerCase();
        if (productType.indexOf('anleitung') !== -1) qty = 1;

        price += qty * variant.price;
      }

      // Digitale Anleitung (auto-add) zum Preis hinzurechnen
      if (this.digitalAutoAddVariantId && this.digitalAutoAddPrice) {
        price += this.digitalAutoAddPrice;
      }
      // Digitale Anleitung (wählbar via instruction-choice) zum Preis hinzurechnen
      var icEl = document.querySelector('.instruction-choice[data-digital-price]');
      if (icEl && icEl._instructionChoice && icEl._instructionChoice.getSelected() === 'digital') {
        var icDigPrice = parseInt(icEl.dataset.digitalPrice || '0', 10);
        price += icDigPrice;
      }
      // Gedruckte Anleitung (gewählt, nicht gratis) ebenfalls – sonst zeigt der Knopf weniger als der Warenkorb
      var icDruck = document.querySelector('.instruction-choice[data-printed-price]');
      if (icDruck && icDruck._instructionChoice && icDruck._instructionChoice.getSelected() === 'printed' && icDruck.dataset.isFree !== 'true') {
        price += parseInt(icDruck.dataset.printedPrice || '0', 10) || 0;
      }

      // Auto-Add Items zum Preis hinzurechnen (Preis kommt aus data-auto-add-items Attribut)
      for (var ai = 0; ai < this.autoAddItems.length; ai++) {
        var autoItem = this.autoAddItems[ai];
        if (!autoItem.price) continue;
        var autoQty = 1;
        if (this.currentConstellation && this.currentConstellation[autoItem.index] !== undefined) {
          autoQty = parseInt(this.currentConstellation[autoItem.index]) || 1;
        }
        if (autoQty === 0) continue;
        price += autoQty * autoItem.price;
      }

      // Preis-Element aktualisieren
      var section = this.closest('section');
      if (section) {
        var priceEl = section.querySelector('price-money');
        if (priceEl) {
          var bdiEl = priceEl.querySelector('bdi');
          var formatted = theme.Currency.formatMoney(price, theme.shopSettings.moneyFormat);
          if (bdiEl) {
            bdiEl.innerHTML = formatted;
          } else {
            priceEl.innerHTML = '<bdi>' + formatted + '</bdi>';
          }
        }
      }
    }

    /* ════════════════════════════════════════════
       Verfügbarkeit prüfen
       ════════════════════════════════════════════ */
    /* ── Fehlerbox über dem Warenkorb-Knopf ──
       Die Box aus buy-buttons.liquid ist mit `hidden` versteckt; ohne sie
       einzublenden sah man bei Stricksets keine Ablehnung durch Shopify.
       (Bestandsengpässe zeigt _displayDeliveryTime unter den Farbwählern.) */
    _hinweisBox() {
      var pf = this.productForm && this.productForm.closest('product-form');
      if (!pf) return null;
      var wrapper = pf.querySelector('.product-form__error-message-wrapper');
      var text = pf.querySelector('.product-form__error-message');
      return wrapper && text ? { wrapper: wrapper, text: text } : null;
    }

    _zeigeHinweis(nachricht, quelle) {
      var box = this._hinweisBox();
      if (!box) return;
      box.text.textContent = nachricht;
      box.text.style.display = '';
      box.wrapper.hidden = false;
      this._hinweisQuelle = quelle;
    }

    _versteckeHinweis(quelle) {
      var box = this._hinweisBox();
      if (!box || (quelle && this._hinweisQuelle !== quelle)) return;
      box.text.textContent = '';
      box.wrapper.hidden = true;
      this._hinweisQuelle = null;
    }

    calculateAvailability() {
      var isAvailable = true;
      var variantTotals = {};

      for (var si = 0; si < this.selectors.length; si++) {
        var selector = this.selectors[si];
        var selectorIndex = parseInt(selector.getAttribute('data-index'));
        var variant = selector.getSelectedVariant();
        if (!variant || !variant.id) continue;

        var qty = 1;
        if (this.currentConstellation && this.currentConstellation[selectorIndex] !== undefined) {
          qty = this.currentConstellation[selectorIndex];
        }
        if (qty === 0) continue;

        var productType = (selector.getAttribute('data-product-type') || '').toLowerCase();
        var isInstruction = productType.indexOf('anleitung') !== -1;
        if (isInstruction) qty = 1;

        var stockEl = selector.querySelector('[data-strickset-variant-stock="' + variant.id + '"]');
        if (!stockEl) {
          // Fallback: alte data-Attribute prüfen
          stockEl = selector.querySelector('[data-multi-variant-stock="' + variant.id + '"]');
        }

        if (stockEl) {
          var stock = parseInt(stockEl.getAttribute('data-stock')) || 0;
          var policy = stockEl.getAttribute('data-inventory-policy') || 'deny';
          var allowsBackorder = policy === 'continue';

          var vid = String(variant.id);
          if (!variantTotals[vid]) {
            variantTotals[vid] = { needed: 0, stock: stock, allowsBackorder: allowsBackorder };
          }
          variantTotals[vid].needed += qty;
        }
      }

      // Prüfen ob genug Stock (den Hinweis dazu zeigt _displayDeliveryTime)
      for (var vid in variantTotals) {
        var info = variantTotals[vid];
        if (info.needed > info.stock && !info.allowsBackorder) {
          isAvailable = false;
          break;
        }
      }

      // Submit-Button steuern
      var section = this.closest('section');
      if (section) {
        var submitBtn = section.querySelector('button[type="submit"], .product-form__submit');
        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          if (!isAvailable) {
            submitBtn.classList.add('disabled');
          } else {
            submitBtn.classList.remove('disabled');
          }
        }
      }

      return isAvailable;
    }

    /* ════════════════════════════════════════════
       Lieferzeit berechnen und anzeigen
       ════════════════════════════════════════════ */
    calculateDeliveryTime() {
      var self = this;
      if (this._deliveryTimeTimeout) {
        clearTimeout(this._deliveryTimeTimeout);
      }
      this._deliveryTimeTimeout = setTimeout(function () {
        self._calculateDeliveryTimeInternal();
      }, 50);
    }

    _calculateDeliveryTimeInternal() {
      var maxDeliveryTime = 5;
      var deliveryDetails = [];

      for (var si = 0; si < this.selectors.length; si++) {
        var selector = this.selectors[si];
        var selectorIndex = parseInt(selector.getAttribute('data-index'));
        var variant = selector.getSelectedVariant();
        if (!variant || !variant.id) continue;

        var qty = 1;
        if (this.currentConstellation && this.currentConstellation[selectorIndex] !== undefined) {
          qty = this.currentConstellation[selectorIndex];
        }
        if (qty === 0) continue;

        var productType = (selector.getAttribute('data-product-type') || '').toLowerCase();
        var isInstruction = productType.indexOf('anleitung') !== -1;
        if (isInstruction) qty = 1;

        var stockEl = selector.querySelector('[data-strickset-variant-stock="' + variant.id + '"]');
        if (!stockEl) {
          stockEl = selector.querySelector('[data-multi-variant-stock="' + variant.id + '"]');
        }

        if (stockEl && qty > 0) {
          var stock = parseInt(stockEl.getAttribute('data-stock')) || 0;
          var variantTitle = stockEl.getAttribute('data-variant-title') || '';
          var policy = stockEl.getAttribute('data-inventory-policy') || 'deny';
          var allowsBackorder = policy === 'continue';

          // Display-Titel bestimmen
          var displayTitle = variantTitle;
          if (displayTitle === 'Default Title' || !displayTitle) {
            displayTitle = stockEl.getAttribute('data-product-title') || 'Komponente ' + (selectorIndex + 1);
          }

          var isBackorder = stock < qty;
          if (isBackorder) {
            maxDeliveryTime = 10;
          }

          deliveryDetails.push({
            title: displayTitle,
            needed: qty,
            available: stock,
            allowsBackorder: allowsBackorder,
            deliveryTime: isBackorder ? 10 : 5
          });
        }
      }

      this._displayDeliveryTime(maxDeliveryTime, deliveryDetails);
    }

    /** Lieferzeit-Anzeige rendern (3 Zustände: ok, backorder, unavailable) */
    _displayDeliveryTime(deliveryTime, details) {
      // Alte Anzeigen entfernen
      var oldDisplays = document.querySelectorAll('.bundle-delivery-simplified');
      oldDisplays.forEach(function (el) { el.remove(); });

      if (!details || details.length === 0) return;

      // SVG-Icons
      var iconOk = '<svg class="delivery-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M6.5 10.5l2 2 5-5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var iconBackorder = '<svg class="delivery-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M10 6v5l3 2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var iconUnavailable = '<svg class="delivery-icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M10 6v5" stroke-linecap="round"/><circle cx="10" cy="13.5" r="0.5" fill="currentColor" stroke="none"/></svg>';

      // Aggregiere pro Farbe
      var colorAgg = {};
      details.forEach(function (d) {
        if (!colorAgg[d.title]) {
          colorAgg[d.title] = { needed: 0, available: d.available, allowsBackorder: d.allowsBackorder };
        }
        colorAgg[d.title].needed += parseInt(d.needed) || 1;
      });

      var backorderColors = [];
      var unavailableColors = [];

      for (var color in colorAgg) {
        var info = colorAgg[color];
        if (info.needed <= info.available) continue;
        if (info.allowsBackorder) {
          backorderColors.push(color);
        } else {
          unavailableColors.push(color);
        }
      }

      var icon = '';
      var text = '';
      var cssClass = '';

      if (unavailableColors.length > 0) {
        cssClass = 'bundle-delivery-simplified--unavailable';
        icon = iconUnavailable;
        var colorList = unavailableColors.join(', ');
        var subject = encodeURIComponent('Anfrage: ' + this.productTitle + ' – Farbe ' + colorList);
        var body = encodeURIComponent('Hallo Lianne-Team,\n\nich interessiere mich für das ' + this.productTitle + '.\nLeider ist die Farbe ' + colorList + ' aktuell nicht verfügbar. Könnt ihr mir sagen, wann diese Farbe wieder lieferbar ist?\n\nVielen Dank und liebe Grüße');
        var mailtoLink = 'mailto:info@lianne.shop?subject=' + subject + '&body=' + body;
        // Genauer als „nicht verfügbar“, wenn nur ein Teil fehlt (z. B. 2 da, 12 nötig)
        var saetze = unavailableColors.map(function (c) {
          var info = colorAgg[c];
          return info.available > 0
            ? 'Von Farbe ' + c + ' sind nur noch ' + info.available + ' Knäuel da, für deine Auswahl brauchst du ' + info.needed + '.'
            : 'Farbe ' + c + ' ist aktuell nicht verfügbar.';
        });
        text = saetze.join(' ') + ' <a href="' + mailtoLink + '">Schreib uns</a> oder wähle eine andere Farbe.';
      } else if (backorderColors.length > 0) {
        cssClass = 'bundle-delivery-simplified--backorder';
        icon = iconBackorder;
        text = 'Farbe ' + backorderColors.join(', ') + ' wird nachbestellt — <strong>Lieferung in bis zu 10 Werktagen</strong>';
      } else {
        cssClass = 'bundle-delivery-simplified--ok';
        icon = iconOk;
        text = 'Verfügbar — <strong>Lieferung in 2–5 Werktagen</strong>';
      }

      var el = document.createElement('div');
      el.className = 'bundle-delivery-simplified ' + cssClass;
      el.innerHTML = icon + '<span>' + text + '</span>';

      // Nach dem Handler einfügen
      if (this.nextSibling) {
        this.parentNode.insertBefore(el, this.nextSibling);
      } else {
        this.parentNode.appendChild(el);
      }
    }

    /* ════════════════════════════════════════════
       Submit-Button reaktivieren
       ════════════════════════════════════════════ */
    reenableSubmitButton() {
      if (!this.productForm) return;
      var submitBtn = this.productForm.querySelector('button[type="submit"], .product-form__submit, button[name="add"]');
      if (!submitBtn) return;

      // Nur aktivieren wenn verfügbar
      if (this.calculateAvailability()) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('disabled');
        submitBtn.classList.remove('disabled');
      }
    }
  }

  customElements.define('strickset-handler', StricksetHandler);

})();
